/* eslint-disable max-len */

// Auth
export const SR_API_ACTION_UTILITY_LOGIN = 'SR_API_ACTION_UTILITY_LOGIN';
export const SR_API_ACTION_UTILITY_LOGONAS = 'SR_API_ACTION_UTILITY_LOGONAS';
export const SR_API_ACTION_UTILITY_CHECK_LOGIN_EXIST = 'SR_API_ACTION_UTILITY_CHECK_LOGIN_EXIST';
export const SR_API_ACTION_UTILITY_USER_SIGNUP = 'SR_API_ACTION_UTILITY_USER_SIGNUP';
export const SR_API_ACTION_UTILITY_PARTNER_SIGNUP = 'SR_API_ACTION_UTILITY_PARTNER_SIGNUP';
export const SR_API_ACTION_UTILITY_VERIFY_ACCOUNT_EXIST =
  'SR_API_ACTION_UTILITY_VERIFY_ACCOUNT_EXIST';
export const SR_API_ACTION_UTILITY_VERIFY_PHONE_SMS_CODE_REQUESTED =
  'SR_API_ACTION_UTILITY_VERIFY_PHONE_SMS_CODE_REQUESTED';
export const SR_API_ACTION_UTILITY_VERIFY_PHONE_SMS_CODE_SUBMIT =
  'SR_API_ACTION_UTILITY_VERIFY_PHONE_SMS_CODE_SUBMIT';
export const SR_API_ACTION_UTILITY_GENERATE_RESET_PASSWORD_TOKEN =
  'SR_API_ACTION_UTILITY_GENERATE_RESET_PASSWORD_TOKEN';
export const SR_API_ACTION_UTILITY_RESET_PASSWORD = 'SR_API_ACTION_UTILITY_RESET_PASSWORD';
export const SR_API_ACTION_UTILITY_USER_SMS_CODE_SIGNUP =
  'SR_API_ACTION_UTILITY_USER_SMS_CODE_SIGNUP';
export const SR_API_ACTION_UTILITY_USER_SMS_CODE_LOGIN =
  'SR_API_ACTION_UTILITY_USER_SMS_CODE_LOGIN';
export const SR_API_ACTION_UTILITY_USER_ACTIVATE_PARTNER_USER_ACCOUNT =
  'SR_API_ACTION_UTILITY_USER_ACTIVATE_PARTNER_USER_ACCOUNT';

// Utility Users
export const SR_API_ACTION_UTILITY_USER_GET_BY_ACTIVATION =
  'SR_API_ACTION_UTILITY_USER_GET_BY_ACTIVATION';
export const SR_API_ACTION_UTILITY_USER_GET_LIST_WITH_ROLE =
  'SR_API_ACTION_UTILITY_USER_GET_LIST_WITH_ROLE';
export const SR_API_ACTION_UTILITY_USER_GET_FROM_API_TEST =
  'SR_API_ACTION_UTILITY_USER_GET_FROM_API_TEST';

// Utility Partners
export const SR_API_ACTION_UTILITY_PARTNER_GET_LIST = 'SR_API_ACTION_UTILITY_PARTNER_GET_LIST';
export const SR_API_ACTION_UTILITY_PARTNER_GET_BY_SLUG =
  'SR_API_ACTION_UTILITY_PARTNER_GET_BY_SLUG';
export const SR_API_ACTION_UTILITY_PARTNER_GET_BY_ID = 'SR_API_ACTION_UTILITY_PARTNER_GET_BY_ID';
export const SR_API_ACTION_UTILITY_PARTNER_CREATE_BCC_REMINDER =
  'SR_API_ACTION_UTILITY_PARTNER_CREATE_BCC_REMINDER';
export const SR_API_ACTION_UTILITY_PARTNER_UPDATE_PROFILE =
  'SR_API_ACTION_UTILITY_PARTNER_UPDATE_PROFILE';
export const SR_API_ACTION_UTILITY_PARTNER_UPDATE_UTILITY_TYPES =
  'SR_API_ACTION_UTILITY_PARTNER_UPDATE_UTILITY_TYPES';
export const SR_API_ACTION_UTILITY_PARTNER_UPSERT_USER =
  'SR_API_ACTION_UTILITY_PARTNER_UPSERT_USER';
export const SR_API_ACTION_UTILITY_PARTNER_SEND_INVITE =
  'SR_API_ACTION_UTILITY_PARTNER_SEND_INVITE';
export const SR_API_ACTION_UTILITY_PARTNER_DELETE_USER =
  'SR_API_ACTION_UTILITY_PARTNER_DELETE_USER';
export const SR_API_ACTION_UTILITY_PARTNER_GET_STRIPE_ACCOUNTS =
  'SR_API_ACTION_UTILITY_PARTNER_GET_STRIPE_ACCOUNTS';
export const SR_API_ACTION_UTILITY_PARTNER_WITHDRAW_PENDING_BALANCE =
  'SR_API_ACTION_UTILITY_PARTNER_WITHDRAW_PENDING_BALANCE';
export const SR_API_ACTION_UTILITY_PARTNER_GET_REVENUE_DETAILS =
  'SR_API_ACTION_UTILITY_PARTNER_GET_REVENUE_DETAILS';
export const SR_API_ACTION_UTILITY_PARTNER_SYNC_PM_SOFTWARE =
  'SR_API_ACTION_UTILITY_PARTNER_SYNC_PM_SOFTWARE';
export const SR_API_ACTION_UTILITY_PARTNER_PM_SOFTWARE_UPSERT =
  'SR_API_ACTION_UTILITY_PARTNER_PM_SOFTWARE_UPSERT';
export const SR_API_ACTION_UTILITY_PARTNER_GET_BY_AUTOCOMPLETE =
  'SR_API_ACTION_UTILITY_PARTNER_GET_BY_AUTOCOMPLETE';
export const SR_API_ACTION_UTILITY_PARTNER_ASSIGN_TO_GMAIL_SENDER =
  'SR_API_ACTION_UTILITY_PARTNER_ASSIGN_TO_GMAIL_SENDER';
export const SR_API_ACTION_UTILITY_PARTNER_INVITE_TEAM_MEMBERS_BY_EMAIL =
  'SR_API_ACTION_UTILITY_PARTNER_INVITE_TEAM_MEMBERS_BY_EMAIL';
export const SR_API_ACTION_UTILITY_PARTNER_AGREE_TO_TOS =
  'SR_API_ACTION_UTILITY_PARTNER_AGREE_TO_TOS';
export const SR_API_ACTION_UTILITY_PARTNER_UPDATE_STATUS =
  'SR_API_ACTION_UTILITY_PARTNER_UPDATE_STATUS';
export const SR_API_ACTION_UTILITY_PARTNER_UPDATE_EXPERIENCE_CONFIGURATION =
  'SR_API_ACTION_UTILITY_PARTNER_UPDATE_EXPERIENCE_CONFIGURATION';

// Utility Partner Provider Notes
export const SR_API_ACTION_UTILITY_PARTNER_PROVIDER_NOTES_GET =
  'SR_API_ACTION_UTILITY_PARTNER_PROVIDER_NOTES_GET';
export const SR_API_ACTION_UTILITY_PARTNER_PROVIDER_NOTES_GET_LIST =
  'SR_API_ACTION_UTILITY_PARTNER_PROVIDER_NOTES_GET_LIST';
export const SR_API_ACTION_UTILITY_PARTNER_PROVIDER_NOTES_CREATE =
  'SR_API_ACTION_UTILITY_PARTNER_PROVIDER_NOTES_CREATE';
export const SR_API_ACTION_UTILITY_PARTNER_PROVIDER_NOTES_UPDATE =
  'SR_API_ACTION_UTILITY_PARTNER_PROVIDER_NOTES_UPDATE';
export const SR_API_ACTION_UTILITY_PARTNER_PROVIDER_NOTES_DELETE =
  'SR_API_ACTION_UTILITY_PARTNER_PROVIDER_NOTES_DELETE';
export const SR_API_ACTION_UTILITY_PARTNER_PROVIDER_NOTES_CHECK_ADDRESS_NOTES =
  'SR_API_ACTION_UTILITY_PARTNER_PROVIDER_NOTES_CHECK_ADDRESS_NOTES';

// Utility Partner Groups
export const SR_API_ACTION_UTILITY_PARTNER_GROUP_GET_BY_ID =
  'SR_API_ACTION_UTILITY_PARTNER_GROUP_GET_BY_ID';
export const SR_API_ACTION_UTILITY_PARTNER_GROUP_GET_PARTNERS =
  'SR_API_ACTION_UTILITY_PARTNER_GROUP_GET_PARTNERS';

// Bank Account
export const SR_API_ACTION_UTILITY_CONNECT_BANK_ACCOUNT =
  'SR_API_ACTION_UTILITY_CONNECT_BANK_ACCOUNT';

// Utility Payouts
export const SR_API_ACTION_UTILITY_PAYOUTS_GET_PENDING_PAYOUTS_BY_PARTNER_SLUG =
  'SR_API_ACTION_UTILITY_PAYOUTS_GET_PENDING_PAYOUTS_BY_PARTNER_SLUG';
export const SR_API_ACTION_UTILITY_PARTNER_SELF_ONBOARDING_STEP_UPDATE =
  'SR_API_ACTION_UTILITY_PARTNER_SELF_ONBOARDING_STEP_UPDATE';

// Utility Profit Tips
export const SR_API_ACTION_UTILITY_PROFIT_TIPS_GET_LIST =
  'SR_API_ACTION_UTILITY_PROFIT_TIPS_GET_LIST';

// Utility Partner Listing Feeds
export const SR_API_ACTION_UTILITY_PARTNER_LISTING_FEED_SYNC =
  'SR_API_ACTION_UTILITY_PARTNER_LISTING_FEED_SYNC';

// Utility Partner Referrals
export const SR_API_ACTION_UTILITY_PARTNER_REFERRALS_GET_PARTNER_EARNINGS =
  'SR_API_ACTION_UTILITY_PARTNER_REFERRALS_GET_PARTNER_EARNINGS';

// Utility Activations
export const SR_API_ACTION_UTILITY_ACTIVATION_CREATE = 'SR_API_ACTION_UTILITY_ACTIVATION_CREATE';
export const SR_API_ACTION_UTILITY_ACTIVATION_CREATE_LAZY_SIGNUP =
  'SR_API_ACTION_UTILITY_ACTIVATION_CREATE_LAZY_SIGNUP';
export const SR_API_ACTION_UTILITY_ACTIVATION_LISTING_HANDOFF =
  'SR_API_ACTION_UTILITY_ACTIVATION_LISTING_HANDOFF';
export const SR_API_ACTION_UTILITY_ACTIVATION_GET_LIST =
  'SR_API_ACTION_UTILITY_ACTIVATION_GET_LIST';
export const SR_API_ACTION_UTILITY_ACTIVATION_GET = 'SR_API_ACTION_UTILITY_ACTIVATION_GET';
export const SR_API_ACTION_UTILITY_ACTIVATION_GET_TYPES_LIST =
  'SR_API_ACTION_UTILITY_ACTIVATION_GET_TYPES_LIST';
export const SR_API_ACTION_UTILITY_ACTIVATION_UPDATE = 'SR_API_ACTION_UTILITY_ACTIVATION_UPDATE';
export const SR_API_ACTION_UTILITY_ACTIVATION_UPDATE_ITEM =
  'SR_API_ACTION_UTILITY_ACTIVATION_UPDATE_ITEM';
export const SR_API_ACTION_UTILITY_ACTIVATION_UPDATE_ITEM_PLAN =
  'SR_API_ACTION_UTILITY_ACTIVATION_UPDATE_ITEM_PLAN';
export const SR_API_ACTION_UTILITY_ACTIVATION_SEND_MISSING_PROVIDER_NOTIFICATION =
  'SR_API_ACTION_UTILITY_ACTIVATION_SEND_MISSING_PROVIDER_NOTIFICATION';
export const SR_API_ACTION_UTILITY_ACTIVATION_UPDATE_SELECTED_PROVIDER =
  'SR_API_ACTION_UTILITY_ACTIVATION_UPDATE_SELECTED_PROVIDER';
export const SR_API_ACTION_UTILITY_ACTIVATION_TRACK_INTERNET_FLOW =
  'SR_API_ACTION_UTILITY_ACTIVATION_TRACK_INTERNET_FLOW';
export const SR_API_ACTION_UTILITY_ACTIVATION_UPDATE_LEASE_START_DATE =
  'SR_API_ACTION_UTILITY_ACTIVATION_UPDATE_LEASE_START_DATE';
export const SR_API_ACTION_UTILITY_ACTIVATION_MISSING_PROVIDERS_AUTO_MAP =
  'SR_API_ACTION_UTILITY_ACTIVATION_MISSING_PROVIDERS_AUTO_MAP';
export const SR_API_ACTION_UTILITY_ACTIVATION_SERVICE_AREAS_AUTO_MAP =
  'SR_API_ACTION_UTILITY_ACTIVATION_SERVICE_AREAS_AUTO_MAP';
export const SR_API_ACTION_UTILITY_ACTIVATION_CREATE_FEEDBACK =
  'SR_API_ACTION_UTILITY_ACTIVATION_CREATE_FEEDBACK';
export const SR_API_ACTION_UTILITY_ACTIVATION_ITEM_GET_PURCHASE_REQUEST_MESSAGE =
  'SR_API_ACTION_UTILITY_ACTIVATION_ITEM_GET_PURCHASE_REQUEST_MESSAGE';
export const SR_API_ACTION_UTILITY_ACTIVATION_ITEM_GET_DELAYED_REASONS_LIST =
  'SR_API_ACTION_UTILITY_ACTIVATION_ITEM_GET_DELAYED_REASONS_LIST';
export const SR_API_ACTION_UTILITY_ACTIVATION_START_ORDER =
  'SR_API_ACTION_UTILITY_ACTIVATION_START_ORDER';
export const SR_API_ACTION_UTILITY_ACTIVATION_GET_ORDER_HITLIST_BY_SALES_REP =
  'SR_API_ACTION_UTILITY_ACTIVATION_GET_ORDER_HITLIST_BY_SALES_REP';
export const SR_API_ACTION_UTILITY_ACTIVATION_TABLE_FILTERS_COUNT =
  'SR_API_ACTION_UTILITY_ACTIVATION_TABLE_FILTERS_COUNT';
export const SR_API_ACTION_UTILITY_ACTIVATION_GET_AUTO_PROCESSABLE_ORDERS =
  'SR_API_ACTION_UTILITY_ACTIVATION_GET_AUTO_PROCESSABLE_ORDERS';
export const SR_API_ACTION_UTILITY_ACTIVATION_ITEM_GET_LINK_REQUEST_BY_ID =
  'SR_API_ACTION_UTILITY_ACTIVATION_ITEM_GET_LINK_REQUEST_BY_ID';
export const SR_API_ACTION_UTILITY_ACTIVATION_GET_INTERNET_PLANS =
  'SR_API_ACTION_UTILITY_ACTIVATION_GET_INTERNET_PLANS';

export const SR_API_ACTION_UTILITY_ACTIVATION_RESET_ITEM =
  'SR_API_ACTION_UTILITY_ACTIVATION_RESET_ITEM';

export const SR_API_ACTIVATION_UTILITY_ORDER_DELAYED = 'SR_API_ACTIVATION_UTILITY_ORDER_DELAYED';

// Address
export const SR_API_ACTION_ADDRESS_GET_BY_ID = 'SR_API_ACTION_ADDRESS_GET_BY_ID';
export const SR_API_ACTION_ADDRESS_REGISTER = 'SR_API_ACTION_ADDRESS_REGISTER';
export const SR_API_ACTION_ADDRESS_REGISTER_ADDRESS_STRING =
  'SR_API_ACTION_ADDRESS_REGISTER_ADDRESS_STRING';
export const SR_API_ACTION_ADDRESS_REGISTER_PARTNER_CONFIRMED =
  'SR_API_ACTION_ADDRESS_REGISTER_PARTNER_CONFIRMED';
export const SR_API_ACTION_ADDRESS_GET_AUTOCOMPLETE = 'SR_API_ACTION_ADDRESS_GET_AUTOCOMPLETE';
export const SR_API_ACTION_ADDRESS_GET_AUTOCOMPLETE_PREDICTIONS =
  'SR_API_ACTION_ADDRESS_GET_AUTOCOMPLETE_PREDICTIONS';
export const SR_API_ACTION_ADDRESS_UPDATE_REQUIRED_TYPES =
  'SR_API_ACTION_ADDRESS_UPDATE_REQUIRED_TYPES';
export const SR_API_ACTION_ADDRESS_SEARCH_TRACK = 'SR_API_ACTION_ADDRESS_SEARCH_TRACK';
export const SR_API_ACTION_ADDRESS_START_REMINDERS_FOR_RENTER =
  'SR_API_ACTION_ADDRESS_START_REMINDERS_FOR_RENTER';
export const SR_API_ACTION_ADDRESS_FCC_SCRAPE = 'SR_API_ACTION_ADDRESS_FCC_SCRAPE';
export const SR_API_ACTION_ADDRESS_FCC_SCRAPE_ALL = 'SR_API_ACTION_ADDRESS_FCC_SCRAPE_ALL';
export const SR_API_ACTION_ADDRESS_FCC_CONFIRM_MAPPING =
  'SR_API_ACTION_ADDRESS_FCC_CONFIRM_MAPPING';

// Utility Partner Address
export const SR_API_ACTION_UTILITY_PARTNER_ADDRESS_UPDATE_ADDRESS =
  'SR_API_ACTION_UTILITY_PARTNER_ADDRESS_UPDATE_ADDRESS';
export const SR_API_ACTION_UTILITY_PARTNER_ADDRESS_GET_BY_ID =
  'SR_API_ACTION_UTILITY_PARTNER_ADDRESS_GET_BY_ID';
export const SR_API_ACTION_UTILITY_PARTNER_ADDRESS_PROPERTY_MANAGER_GET_AUTOCOMPLETE =
  'SR_API_ACTION_UTILITY_PARTNER_ADDRESS_PROPERTY_MANAGER_GET_AUTOCOMPLETE';
export const SR_API_ACTION_UTILITY_PARTNER_ADDRESS_GET_RECENTLY_UNLISTED_ADDRESSES =
  'SR_API_ACTION_UTILITY_PARTNER_ADDRESS_GET_RECENTLY_UNLISTED_ADDRESSES';
export const SR_API_ACTION_UTILITY_PARTNER_ADDRESS_REQUIRED_DOCS_UPSERT =
  'SR_API_ACTION_UTILITY_PARTNER_ADDRESS_REQUIRED_DOCS_UPSERT';
export const SR_API_ACTION_UTILITY_PARTNER_ADDRESS_AUTO_MAP_PROVIDERS =
  'SR_API_ACTION_UTILITY_PARTNER_ADDRESS_AUTO_MAP_PROVIDERS';
export const SR_API_ACTION_UTILITY_PARTNER_ADDRESS_VERIFICATION_START =
  'SR_API_ACTION_UTILITY_PARTNER_ADDRESS_VERIFICATION_START';
export const SR_API_ACTION_UTILITY_PARTNER_ADDRESS_VERIFICATION_END =
  'SR_API_ACTION_UTILITY_PARTNER_ADDRESS_VERIFICATION_END';
export const SR_API_ACTION_UTILITY_PARTNER_ADDRESS_CREATE_MAPPING_DEFAULT =
  'SR_API_ACTION_UTILITY_PARTNER_ADDRESS_CREATE_MAPPING_DEFAULT';
export const SR_API_ACTION_UTILITY_PARTNER_ADDRESS_DELETE_MAPPING_DEFAULT =
  'SR_API_ACTION_UTILITY_PARTNER_ADDRESS_DELETE_MAPPING_DEFAULT';
export const SR_API_ACTION_UTILITY_PARTNER_ADDRESS_ARCHIVE =
  'SR_API_ACTION_UTILITY_PARTNER_ADDRESS_ARCHIVE';
export const SR_API_ACTION_UTILITY_PARTNER_ADDRESS_GET_LOOKUP_SUGGESTIONS =
  'SR_API_ACTION_UTILITY_PARTNER_ADDRESS_GET_LOOKUP_SUGGESTIONS';

// Address Resolution
export const SR_API_ACTION_ADDRESS_RESOLUTION_MARK_AS_RESOLVED =
  'SR_API_ACTION_ADDRESS_RESOLUTION_MARK_AS_RESOLVED';
export const SR_API_ACTION_ADDRESS_RESOLUTION_MARK_AS_IGNORED =
  'SR_API_ACTION_ADDRESS_RESOLUTION_MARK_AS_IGNORED';
export const SR_API_ACTION_ADDRESS_RESOLUTION_ATTEMPTS_BULK_IGNORE =
  'SR_API_ACTION_ADDRESS_RESOLUTION_ATTEMPTS_BULK_IGNORE';
export const SR_API_ACTION_LISTINGS_VERIFICATION_BULK_ARCHIVE =
  'SR_API_ACTION_LISTINGS_VERIFICATION_BULK_ARCHIVE';

// Utility Providers
export const SR_API_ACTION_UTILITY_PROVIDER_GET_LIST = 'SR_API_ACTION_UTILITY_PROVIDER_GET_LIST';
export const SR_API_ACTION_UTILITY_PROVIDER_GET_BY_ADDRESS_ID =
  'SR_API_ACTION_UTILITY_PROVIDER_GET_BY_ADDRESS_ID';
export const SR_API_ACTION_UTILITY_PROVIDER_UPDATE_ADDRESS_COVERAGE =
  'SR_API_ACTION_UTILITY_PROVIDER_UPDATE_ADDRESS_COVERAGE';
export const SR_API_ACTION_UTILITY_PROVIDER_ADD_ADDRESS_COVERAGE =
  'SR_API_ACTION_UTILITY_PROVIDER_ADD_ADDRESS_COVERAGE';
export const SR_API_ACTION_UTILITY_PROVIDER_REMOVE_ADDRESS_COVERAGE =
  'SR_API_ACTION_UTILITY_PROVIDER_REMOVE_ADDRESS_COVERAGE';
export const SR_API_ACTION_UTILITY_PROVIDER_GET_ADDRESS_COVERAGE =
  'SR_API_ACTION_UTILITY_PROVIDER_GET_ADDRESS_COVERAGE';
export const SR_API_ACTION_UTILITY_PROVIDER_UPSERT = 'SR_API_ACTION_UTILITY_PROVIDER_UPSERT';
export const SR_API_ACTION_UTILITY_PROVIDER_GET_BY_AUTOCOMPLETE =
  'SR_API_ACTION_UTILITY_PROVIDER_GET_BY_AUTOCOMPLETE';
export const SR_API_ACTION_UTILITY_PROVIDER_MARK_AS_TENANT_REMOVED =
  'SR_API_ACTION_UTILITY_PROVIDER_MARK_AS_TENANT_REMOVED';
export const SR_API_ACTION_UTILITY_PROVIDER_GET_MAPPED_PROVIDERS_IN_RANGE =
  'SR_API_ACTION_UTILITY_PROVIDER_GET_MAPPED_PROVIDERS_IN_RANGE';
export const SR_API_ACTION_UTILITY_PROVIDER_GET_CONFIDENCE =
  'SR_API_ACTION_UTILITY_PROVIDER_GET_CONFIDENCE';
export const SR_API_ACTION_UTILITY_PROVIDER_OVERRIDE_URL_VALIDATE =
  'SR_API_ACTION_UTILITY_PROVIDER_OVERRIDE_URL_VALIDATE';
export const SR_API_ACTION_UTILITY_PROVIDER_OVERRIDE_UPSERT =
  'SR_API_ACTION_UTILITY_PROVIDER_OVERRIDE_UPSERT';

// Utility Dealers
export const SR_API_ACTION_UTILITY_DEALER_GET_LIST = 'SR_API_ACTION_UTILITY_DEALER_GET_LIST';

// Utility Types
export const SR_API_ACTION_UTILITY_TYPE_GET_LIST = 'SR_API_ACTION_UTILITY_TYPE_GET_LIST';

// Utility Invoices
export const SR_API_ACTION_UTILITY_INVOICE_UPDATE = 'SR_API_ACTION_UTILITY_INVOICE_UPDATE';
export const SR_API_ACTION_UTILITY_INVOICE_CREATE = 'SR_API_ACTION_UTILITY_INVOICE_CREATE';

// Utility Payouts
export const SR_API_ACTION_UTILITY_PAYOUT_UPDATE = 'SR_API_ACTION_UTILITY_PAYOUT_UPDATE';

// Algolia Search
export const SR_API_ACTION_UTILITY_ALGOLIA_RESET_INDEX =
  'SR_API_ACTION_UTILITY_ALGOLIA_RESET_INDEX';

// Utility Partner Notes
export const SR_API_ACTION_UTILITY_PARTNER_NOTE_CREATE =
  'SR_API_ACTION_UTILITY_PARTNER_NOTE_CREATE';
export const SR_API_ACTION_UTILITY_PARTNER_NOTE_DELETE =
  'SR_API_ACTION_UTILITY_PARTNER_NOTE_DELETE';

// Utility Activation Notes
export const SR_API_ACTION_UTILITY_ACTIVATION_NOTE_CREATE =
  'SR_API_ACTION_UTILITY_ACTIVATION_NOTE_CREATE';
export const SR_API_ACTION_UTILITY_ACTIVATION_NOTE_DELETE =
  'SR_API_ACTION_UTILITY_ACTIVATION_NOTE_DELETE';

// Utility Activation Files
export const SR_API_ACTION_UTILITY_ACTIVATION_FILE_CREATE =
  'SR_API_ACTION_UTILITY_ACTIVATION_FILE_CREATE';
export const SR_API_ACTION_UTILITY_ACTIVATION_FILE_DELETE =
  'SR_API_ACTION_UTILITY_ACTIVATION_FILE_DELETE';

// Utility Provider Service Areas
export const SR_API_ACTION_SERVICE_AREA_INGEST_AREAS = 'SR_API_ACTION_SERVICE_AREA_INGEST_AREAS';
export const SR_API_ACTION_SERVICE_AREA_GET_BY_POINT = 'SR_API_ACTION_SERVICE_AREA_GET_BY_POINT';
export const SR_API_ACTION_UTILITY_SERVICE_AREA_PROVIDER_MAPPING =
  'SR_API_ACTION_UTILITY_SERVICE_AREA_PROVIDER_MAPPING';

// Listings Scraper
export const SR_API_ACTION_LISTINGS_SCRAPER_SCRAPE_URL =
  'SR_API_ACTION_LISTINGS_SCRAPER_SCRAPE_URL';
export const SR_API_ACTION_LISTINGS_SCRAPER_SCRAPE_BY_PARTNER_SLUG =
  'SR_API_ACTION_LISTINGS_SCRAPER_SCRAPE_BY_PARTNER_SLUG';

// Util/Scripts
export const SR_API_ACTION_UTILITY_TENANT_BULK_IMPORT = 'SR_API_ACTION_UTILITY_TENANT_BULK_IMPORT';
export const SR_API_ACTION_UTILITY_TENANT_BULK_VALIDATION =
  'SR_API_ACTION_UTILITY_TENANT_BULK_VALIDATION';
export const SR_API_ACTION_UTILITY_CRON_JOB_MISSING_INTERNET_PLAN_VARIANTS_STATUS_GET =
  'SR_API_ACTION_UTILITY_CRON_JOB_MISSING_INTERNET_PLAN_VARIANTS_STATUS_GET';
export const SR_API_ACTION_UTILITY_CRON_JOB_MISSING_INTERNET_PLAN_VARIANTS_STATUS_SET =
  'SR_API_ACTION_UTILITY_CRON_JOB_MISSING_INTERNET_PLAN_VARIANTS_STATUS_SET';

// File Bulk Import
export const SR_API_ACTION_UTILITY_BULK_FILE_IMPORT_PROCESS =
  'SR_API_ACTION_UTILITY_BULK_FILE_IMPORT_PROCESS';
export const SR_API_ACTION_UTILITY_BULK_FILE_IMPORT_TEST =
  'SR_API_ACTION_UTILITY_BULK_FILE_IMPORT_TEST';

// Automatic Orders
export const SR_API_ACTION_AUTOMATED_ORDER_PLACER_PLACE_ORDER =
  'SR_API_ACTION_AUTOMATED_ORDER_PLACER_PLACE_ORDER';
export const SR_API_ACTION_AUTOMATIC_ORDERS_GET_ORDERS_SCREENSHOTS =
  'SR_API_ACTION_AUTOMATIC_ORDERS_GET_ORDERS_SCREENSHOTS';
export const SR_API_ACTION_AUTOMATIC_ORDERS_REVIEW_ORDER =
  'SR_API_ACTION_AUTOMATIC_ORDERS_REVIEW_ORDER';

// Metabase Charts
export const SR_API_ACTION_UTILITY_METABASE_CHART_LOAD_IFRAME_URLS =
  'SR_API_ACTION_UTILITY_METABASE_CHART_LOAD_IFRAME_URLS';
export const SR_API_ACTION_UTILITY_METABASE_CHART_GET_BY_PARTNER_ID =
  'SR_API_ACTION_UTILITY_METABASE_CHART_GET_BY_PARTNER_ID';

// Announcements
export const SR_API_ACTION_UTILITY_ANNOUNCEMENT_TRACK_DISMISS =
  'SR_API_ACTION_UTILITY_ANNOUNCEMENT_TRACK_DISMISS';
export const SR_API_ACTION_UTILITY_ANNOUNCEMENT_SHOULD_SHOW =
  'SR_API_ACTION_UTILITY_ANNOUNCEMENT_SHOULD_SHOW';

// Insurance Policy
export const SR_API_ACTION_INSURANCE_POLICY_GET_DOWNLOAD_URL =
  'SR_API_ACTION_INSURANCE_POLICY_GET_DOWNLOAD_URL';

export const SR_API_ACTION_INSURANCE_POLICY_GET_UPLOAD_URL =
  'SR_API_ACTION_INSURANCE_POLICY_GET_UPLOAD_URL';

export const SR_API_ACTION_INSURANCE_POLICY_MARK_PAID = 'SR_API_ACTION_INSURANCE_POLICY_MARK_PAID';

export const SR_API_ACTION_INSURANCE_POLICY_CANCEL = 'SR_API_ACTION_INSURANCE_POLICY_CANCEL';

export const SR_API_ACTION_INSURANCE_ENABLE_FOR_PARTNER =
  'SR_API_ACTION_INSURANCE_ENABLE_FOR_PARTNER';

export const SR_API_ACTION_INSURANCE_GET_PROPERTY_MANAGER_DETAILS =
  'SR_API_ACTION_INSURANCE_GET_PROPERTY_MANAGER_DETAILS';

export const SR_API_ACTION_INSURANCE_UPDATE_PROPERTY_MANAGER_DETAILS =
  'SR_API_ACTION_INSURANCE_UPDATE_PROPERTY_MANAGER_DETAILS';

export const SR_API_ACTION_INSURANCE_BACKFILL_STATUS =
  'SR_API_ACTION_INSURANCE_BACKFILL_STATUS';

export const SR_API_ACTION_INSURANCE_ADMIN_UPLOAD_EXTERNAL_POLICY =
  'SR_API_ACTION_INSURANCE_ADMIN_UPLOAD_EXTERNAL_POLICY';

// OnSwitch
export const SR_API_ACTION_ONSWITCH_GET_ORDER_WORKFLOW_CONTEXT =
  'SR_API_ACTION_ONSWITCH_GET_ORDER_WORKFLOW_CONTEXT';
